import React from 'react';
// import * as loader from '../Assets/Preloaders/25.gif'
import styled from 'styled-components'
import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined';
import { connect } from 'react-redux';
import { remFinStruc } from '../Actions/Finance_actions';

const TEXTB = styled.small`
display: block;
margin-left: auto;
font-size: larger;
margin-right: auto;
color: #b19a9a;
width: fit-content;
margin-top: 5rem;
`

const ListPills = ({pillVal, dispatch}) => {
  
     if(pillVal.length !== 0 ) {
         
        return ( 
            <>
    
     <section style={{marginTop: '1rem', display: 'flex', flexWrap:'wrap', justifyContent:'space-around', alignContent:'space-between'}}>
            
            {
                pillVal.map((pill, i) =>{ 
                 
                   

              return ( 
              <div key={i} style={{height: 'fit-centent', background:'white', padding:'1rem', borderRadius:'1rem', marginTop: '3rem',}}>
    
    <CheckCircleOutlineOutlinedIcon style={{ fontSize: 'normal', verticalAlign: 'sub', color:`${pill.color}` }} />
    
    <span style={{ marginLeft: '3rem', verticalAlign: 'sup', fontSize:'large', fontWeight:'bold'}}> {pill.budg} - {pill.rPerc}% </span> 
    <span style={{background:'silver', padding:'.5rem', borderRadius:'1rem' ,marginLeft:'1rem', cursor:'pointer'}} onClick={() => dispatch(remFinStruc(pill._id))}>remove</span>
    </div>)
                 }
                
                )
            }
        
    
    </section>
    
    
    
            </>
         );
    }  
       return (
            <>  
            {/* <img 
            src={loader} 
            alt='preloader' 
            style={{marginTop:'10vh', display:'block', marginLeft:'20%'}} />  */}
            <TEXTB  style={{display:'block', marginLeft:'20%'}} >No budget included yet, waiting...</TEXTB> 
             </>
             ) 
   
   
}
  
export default connect()(ListPills);